import VideoListView from "@/views/admin/videos/VideoListView";
import VideoCreateView from "@/views/admin/videos/VideoCreateView";
import VideoEditView from "@/views/admin/videos/VideoEditView";
import VideoDetailView from "@/views/admin/videos/VideoDetailView";

export default [
  {
    name: "pages.admin.videos",
    path: "videos",
    component: VideoListView
  },
  {
    name: "pages.admin.videos.create",
    path: "videos/create",
    component: VideoCreateView
  },
  {
    name: "pages.admin.videos.show",
    path: "videos/:id",
    component: VideoDetailView
  },
  {
    name: "pages.admin.videos.edit",
    path: "videos/:id/edit",
    component: VideoEditView
  },
];
